import { StyledBackdrop } from './styles';

const Backdrop = () => {
    return <StyledBackdrop />;
};

export default Backdrop;
